import { DatePicker } from "@material-ui/pickers";
import { required, useAuthenticated } from "react-admin";
import { GenericDateOrTimePicker } from "../../common/form/GenericDateOrTimePicker";
import { RouteComponentProps } from "react-router-dom";
import { ReportForm } from "../common/ReportForm";
import { ReportClient } from "../../common/reports/ReportClient";
import { RaDriverPicker } from "../../common/form/RaDriverPicker";
import { useCallback } from "react";
import { startOfDay } from "date-fns";

interface Props extends RouteComponentProps {}

interface IDailyLogsReportData {
  dateFrom: Date;
  dateTo: Date;
  driverId: number;
}

export const DailyLogsReport = (props: Props) => {
  useAuthenticated();

  const transformDates = useCallback((input: any) => {
    console.log(input);
    const data = input as IDailyLogsReportData;
    data.dateFrom = startOfDay(data.dateFrom);
    data.dateTo = startOfDay(data.dateTo);
    return data;
  }, []);

  return (
    <ReportClient>
      <ReportForm
        transform={transformDates}
        reportName="daily-logs-report"
        {...props}
        title="resources.reports.dailyLogs.name"
        submitMethod={(x) => x.reportDailylogsreportPost}
      >
        <GenericDateOrTimePicker
          PickerComponent={DatePicker}
          source="dateFrom"
          options={{
            autoOk: true,
            format: "MMMM do yyyy",
          }}
          validate={required()}
        />
        <GenericDateOrTimePicker
          PickerComponent={DatePicker}
          source="dateTo"
          options={{
            autoOk: true,
            format: "MMMM do yyyy",
          }}
          validate={required()}
        />
        <RaDriverPicker source="driverId" validate={required()} />
      </ReportForm>
    </ReportClient>
  );
};
